import type { Brand } from './brand';
import type { Locale } from './locale';
import { formatPrice } from 'utils/currencyUtils';

export type RawMoney = Brand<number, 'RawMoney'>;

export function rawMoney(n: number): RawMoney {
  return n as RawMoney;
}

export type Money = Brand<{ locale: Locale; value: RawMoney }, 'Money'>;

export function money(currency: Locale, n: number): Money {
  return { locale: currency, value: rawMoney(n) } as Money;
}

export type FormattedMoney = Brand<string, 'FormattedMoney'>;

export type FormatMoneyOptions = {
  alwaysShowDecimals?: boolean;
};

const defaultFormatMoneyOptions: FormatMoneyOptions = Object.freeze({});

export function formatMoney(
  fm: Money,
  options: FormatMoneyOptions = defaultFormatMoneyOptions
): FormattedMoney {
  const { locale, value } = fm;
  // If the price is a round number, leave the decimals out
  if (!options.alwaysShowDecimals && Number.isInteger(value)) {
    return formatPrice(value, { precision: 0, locale }) as FormattedMoney;
  }
  // Otherwise render with locale specific precision
  return formatPrice(value, { locale }) as FormattedMoney;
}

export function isEqual(a: Money, b: Money): boolean {
  return JSON.stringify(a) === JSON.stringify(b);
}
